import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { font, color, mediaQuery } = baseVariables;

export const StyledDesktopCalendar = styled.div<{ align?: string }>`
  position: relative;

  .m-dropdown-container {
    padding: ${toRem(24)};
    position: absolute;
    z-index: 10;
    top: ${toRem(64)};
    left: 0;
    width: ${toRem(360)};
    box-shadow: 0 ${toRem(7)} ${toRem(20)} 0 rgba(0, 0, 0, 0.25);
    border-radius: ${toRem(8)};

    @media ${mediaQuery.md} {
      ${props => `${props.align === 'right' ? 'right' : 'left'}: ${toRem(-10)};`};
    }

    @media ${mediaQuery.lg} {
      padding: ${toRem(24)};
      width: ${toRem(712)};
    }

    .m-dropdown-content {
      max-height: none;
      border-radius: 0;
    }

    .tab-wrapper {
      box-shadow: none;

      ul {
        width: ${toRem(270)};
        margin: 0 auto;
        margin-bottom: ${toRem(16)};
      }
      &.container {
        padding: 0 !important;
      }
    }
  }

  .reset-cta {
    background: transparent;
    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${toRem(1)};
    }
  }

  .calendar-footer {
    display: flex;
    justify-content: space-between;

    .w-100 {
      width: 100%;
    }
  }

  .m-input-field {
    &.focus-input {
      input {
        border-color: ${color.base10};
        box-shadow: 0 0 0 ${toRem(0.5)} inset;
      }
    }
  }

  .calendar-badge {
    background-color: ${color.neutral20};
    color: ${color.base10};
    font-family: ${font.fontFamilySwiss};
    font-size: ${font.fontXs};
    padding: ${toRem(6)} ${toRem(8)};
    border-radius: ${toRem(4)};
  }

  .m-switcher-tab-list-item {
    font-weight: ${font.fontWeightMedium};
    &.active span {
      color: ${color.base10};
    }
  }
`;
